/* eslint-disable */
const ONE_DAY = 1000 * 3600 * 24;

const fullMonthName = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const fullWeekName = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const fillZero = (num) => {
    return num < 10 ? '0' + num : num;
};

const timeDist = (date1, date2) => {
    date2 = date2 || new Date(date1.getFullYear(), 0, 1);
    return date1 - date2;
};

const pri = {
    // d: 月份中的第几天，有前导零的 2位数字，01 到 31
    d(d) {
        return fillZero(this.j(d));
    },
    // D：星期中的第几天，文本表示，3个字母，Mon 到 Sun
    D(d) {
        return this.l(d).substr(0, 3);
    },
    // j:月份中的第几天，没有前导零，1 到 31
    j(d) {
        return d.getDate();
    },
    // l: 星期几，完整的文本格式，Sunday 到 Saturday
    l(d) {
        return fullWeekName[d.getDay()];
    },
    // N：ISO-8601 格式数字表示的星期中的第几天，1（表示星期一）到 7（表示星期天）
    N(d) {
        return this.w(d) || 7;
    },
    // w：星期中的第几天，数字表示，0（表示星期天）到 6（表示星期六）
    w(d) {
        return d.getDay();
    },
    // z: 一年中的第几天，0 到 366
    z(d) {
        return Math.floor(timeDist(d) / 86400000);
    },
    // F：月份，完整的文本格式，例如 January 或者 March，January 到 December
    F(d) {
        return fullMonthName[d.getMonth()];
    },
    // m：数字表示的月份，有前导零， 01 到 12
    m(d) {
        return fillZero(this.n(d));
    },
    // n：数字表示的月份，没有前导零，1 到 12
    n(d) {
        return d.getMonth() + 1;
    },
    // M：三个字母缩写表示的月份，Jan 到 Dec
    M(d) {
        return this.F(d).substr(0, 3);
    },
    // Y：4 位数字表示的年份
    Y(d) {
        return d.getFullYear();
    },
    // y：2 位数字表示的年份
    y(d) {
        return this.Y(d)
            .toString()
            .slice(-2);
    },
    // a：显示am/pm
    a(d) {
        return d.getHours() < 12 ? 'am' : 'pm';
    },
    // A：显示AM/PM
    A(d) {
        return this.a(d).toUpperCase();
    },
    // g：小时，12 小时格式，没有前导零，1 到 12
    g(d) {
        return d.getHours() % 12 || 12;
    },
    // G：小时，24 小时格式，没有前导零，0 到 23
    G(d) {
        return d.getHours();
    },
    // h：小时，12 小时格式，有前导零，01 到 12
    h(d) {
        return fillZero(this.g(d));
    },
    // H：小时，24 小时格式，有前导零，00 到 23
    H(d) {
        return fillZero(this.G(d));
    },
    // i：有前导零的分钟数，00 到 59
    i(d) {
        return fillZero(d.getMinutes());
    },
    // s：秒数，有前导零，00 到 59
    s(d) {
        return fillZero(d.getSeconds());
    }
};

const dateTool = {
    format(expr, date) {
        expr = expr || 'Y-m-d H:i:s';

        if (arguments.length == 1) {
            date = new Date();
        } else if (!(date instanceof Date)) {
            date = new Date(parseInt(date) || 0);
        }
        return expr.replace(/\\?([a-z])/gi, function(str, $1) {
            if (pri[str]) {
                return pri[str].call(pri, date);
            } else {
                return $1;
            }
        });
    },

    isLeapYear(year) {
        year.getTime && (year = dateTool.format('Y', year));
        year = parseInt(year, 10);
        return !!(0 == year % 4 && (year % 100 != 0 || year % 400 == 0));
    },

    lastDay(date) {
        return new Date(+date - ONE_DAY);
    },

    nextDay(date) {
        return new Date(+date + ONE_DAY);
    },

    lastMonth(date) {
        let cloned = new Date(+date);
        cloned.setMonth(cloned.getMonth() - 1);
        return cloned;
    },

    nextMonth(date) {
        let cloned = new Date(+date);
        cloned.setMonth(cloned.getMonth() + 1);
        return cloned;
    },

    lastYear(date) {
        let cloned = new Date(+date);
        cloned.setYear(cloned.getFullYear() - 1);
        return cloned;
    },

    nextYear(date) {
        let cloned = new Date(+date);
        cloned.setYear(cloned.getFullYear() + 1);
        return cloned;
    },

    daysBetween(start, end) {
        return parseInt(+end / ONE_DAY, 10) - parseInt(+start / ONE_DAY, 10);
    },

    isSameDay(date1, date2) {
        date1 = new Date(date1);
        date2 = new Date(date2);
        date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        return dateTool.daysBetween(date1, date2) === 0;
    },

    timestamp(date) {
        return parseInt(+date / 1000, 10);
    }
};

export default dateTool;
